export function DatasetsPage() {
  return (
    <section className="empty-page">
      <span className="eyebrow">数据治理</span>
      <h1>数据与产物</h1>
      <p>后续将在这里管理原始文件、标准化数据、质量问题、报告与完整溯源。</p>
    </section>
  );
}
